// extracted by mini-css-extract-plugin
export default {"messageListItem":"MessageItem_messageListItem__HA6F6","messageAvatar":"MessageItem_messageAvatar__pOiXP","messageListItemContent":"MessageItem_messageListItemContent__Qdetp"};